import { get } from "lodash";
import React from "react";
import { useFormContext } from "react-hook-form";

import { HookFormError } from "../Error";

import "./styles.scss";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  name: string;
  label?: string;
}

export const Input = (props: InputProps) => {
  const { register, formState } = useFormContext();

  const error = get(formState, `errors.${props.name}.message`, null);

  return (
    <>
      {props.label && (
        <label className="hook-form-input-label" htmlFor={props.name}>
          {props.label}
        </label>
      )}
      <input className="hook-form-input" {...props} {...register(props.name)} />
      {error && (
        <div className="hook-form-status-display">
          <HookFormError error={error} />
        </div>
      )}
    </>
  );
};
